import React, { useEffect, useState } from 'react';

/**
 * High5On: On global ekibiyle toplantı için High5 x On veri destesi (24 Eyl 2026).
 * Route: /r/high5-on (sidebar YOK, tam ekran slayt, 11 slayt 16:9, İngilizce).
 * Yeniden üretmek için: node src/pages/high5-on/build.js (PDF dahil)
 *
 * 🔴 iframe'e sandbox EKLEME, PDF indirme kırılır.
 * HTML modülü ~67KB, ana bundle'da işi yok: dinamik import ile yükleniyor.
 */
export default function High5On() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('./high5OnHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px;color:#1d1d1f">Sunum yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  // Yükleme zemini sunumun kendi zemini (--deck) ile aynı, açılışta flaş olmasın.
  if (!html) return <div style={{ ...fill, background: '#F0F0F2' }} />;

  return (
    <iframe
      title="On at High5 · In Numbers"
      srcDoc={html}
      style={fill}
    />
  );
}
